import { useDispatch, useSelector } from "react-redux";

import { ReduxState } from "Store/rootReducer";
import { FormikProps } from "formik";
import { useEffect } from "react";
import { PostNumberEntity } from "./postNumberInterfaces";
import { fetchCityStart } from "./postNumberSlice";

interface CityFormState {
  readonly city?: string;
  readonly postNumber?: string;
  readonly validPostNumber?: boolean;
}

export const useFetchedCity = <T extends FormikProps<CityFormState>>(
  field: keyof CityFormState,
  formProps: T,
  invalidPostNumberText: string,
): PostNumberEntity => {
  const dispatch = useDispatch();
  const { postNumber: postNumberEntity } = useSelector(
    (state: ReduxState) => state,
  );
  useEffect(() => {
    if (formProps.values.postNumber) {
      formProps.setFieldTouched("postNumber");
      if (
        formProps.values.postNumber.length === 4 &&
        postNumberEntity.current !== null
      ) {
        if (postNumberEntity.current.valid) {
          formProps.setFieldValue(field, postNumberEntity.current.result);
          formProps.setFieldValue(
            "validPostNumber",
            postNumberEntity.current.valid,
          );
        } else {
          formProps.setFieldValue(field, invalidPostNumberText);
          formProps.setFieldValue(
            "validPostNumber",
            postNumberEntity.current.valid,
          );
        }
      } else {
        formProps.setFieldValue(field, formProps.values[field] ?? "");
        formProps.setFieldValue(
          "validPostNumber",
          formProps.values.validPostNumber,
        );
      }
      if (
        formProps.values.postNumber.length === 4 &&
        formProps.values.city !== undefined &&
        postNumberEntity.current === null
      ) {
        dispatch(fetchCityStart(formProps.values.postNumber));
      }
    }
  }, [postNumberEntity.current, formProps.values.postNumber]);

  return postNumberEntity;
};
